/**
 * WooCommerce Product Single Scripts
 *
 * @since   1.0.0
 * @package premier
 */

(function($) {
    $(document).ready(function() {

        var wooProductPage = $('.single-product');

        if (wooProductPage.length < 1) {
            return;
        }

		var requestQuoteModule = (function() {

			var init = function() {
				var requestQuoteBtns = document.querySelectorAll('.request-quote');
				var requestQuoteGform = document.querySelector('.gform_wrapper form');

				function showForm(e) {
					e.preventDefault();

					if (requestQuoteGform !== null) {
						var requestQuoteTl = new TimelineMax();
						requestQuoteTl
							.to(requestQuoteGform, 0.5, {
								autoAlpha: 1,
								display: 'block',
								ease: Circ.easeOut
							}, 'tl')
							.to(window, 0.5, {
								scrollTo: {
									y: requestQuoteGform,
									autoKill: false
								},
								ease: Circ.easeOut
							}, 'tl+=0.2');
					}
				}

				TweenMax.set(requestQuoteGform, {
					autoAlpha: 0,
					display: 'none'
				});

				for (var i = 0; i < requestQuoteBtns.length; i++) {
					requestQuoteBtns[i].addEventListener('click', showForm);
				}
			};

			return {
				init: init
			};
		})();

		var noticesBarModule = (function() {

			var init = function() {
				var noticesWrapper = document.querySelector('.woocommerce-notices-wrapper');
				if (noticesWrapper.children.length > 0) {
					var wcMessage = noticesWrapper.firstElementChild;
					var viewLink = wcMessage.firstElementChild;
					viewLink.insertAdjacentHTML('beforeend', '<i class="fas fa-truck"></i>');
				}
			};

			return {
				init: init
			};
		})();

		var adjustTitleModule = (function() {

			var init = function() {
				var title = document.querySelector('.product_title');
				if (title.innerText.length > 32) {
					title.classList.add('shrink-text');
				}
			};

			return {
				init: init
			};
		})();

		requestQuoteModule.init();
		noticesBarModule.init();
		adjustTitleModule.init();

    }); // document.ready
})(jQuery);
